// extracted by mini-css-extract-plugin
module.exports = {"centerbg":"centerView_centerbg__1LWG5","center_box_img":"centerView_center_box_img__1BwcO","hide":"centerView_hide__2xWbM"};